
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-spaces/[deskName]",
      function () {
        return require("private-next-pages/office-spaces/[deskName].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-spaces/[deskName]"])
      });
    }
  